<template>
    <v-container fluid :style="{'background-color':$store.getters.getColorPalette().backgroundColorCode}">
        <v-row>
            <v-col>
                <SKUTable />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import SKUTable from '@/components/lists/derived/SKUTable'
export default {
    name:'SKUPage',
    components:{
        SKUTable
    }
}
</script>